import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';

import ListConfiscationAndRefund from './submodules/list';
import SelectConfiscation from './submodules/selectConfiscation';

const ConfiscationAndRefundDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.confiscationAndRefund}
				configActionName={ACTION.getConfiscationAndRefundRequestInBulk}
				path={`${path}/list`}
				component={ListConfiscationAndRefund}
			/>
			<AuthorizedRouteV2
				configPageName={MISCELLANEOUS_RESOURCES.confiscationAndRefund}
				path={`${path}/selectConfiscation`}
				component={SelectConfiscation}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ConfiscationAndRefundDashboard;
